export default "/images/banner-team-discussion.jpg";